module.exports = __webpack_public_path__ + "img/tuxsuite_green_icons-02.fca22942.png";